export const USER_BUILDING_VIEW_TOPIC = 'user-building-view-%d';
export const USER_DEFENSES_VIEW_TOPIC = 'user-defenses-view-%d';
export const USER_RESEARCH_VIEW_TOPIC = 'user-research-view-%d';
export const USER_SHIPS_VIEW_TOPIC = 'user-ships-view-%d';